module.exports = __webpack_public_path__ + "img/375.5da6063d.jpg";